import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { SpinnerService } from '../../services/spinner.service';
import { BrandingService } from 'src/app/services/branding.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [ProgressSpinnerModule, TranslateModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
})
export class SpinnerComponent {
  private readonly brandingService = inject(BrandingService);
  private readonly translate = inject(TranslateService);
  readonly spinnerService = inject(SpinnerService);

  readonly active = this.spinnerService.active;
  readonly showLogo = this.spinnerService.showLogo;
  readonly message = this.spinnerService.message;

  readonly logo = toSignal(this.brandingService.applicationLogo$);
  readonly appTitle = toSignal(this.brandingService.appTitle$);

  isActive() {
    return this.spinnerService.active();
  }
  getMessage() {
    return this.spinnerService.message() ?? this.translate.instant('i18n.Common.loading');
  }
  isLogoVisible() {
    return this.spinnerService.showLogo();
  }
}
